module.exports = __webpack_public_path__ + "components/country-flag/static/pn-00ffa62f5dfc08823c2513d293da79b6.svg";